// green features
export const GREEN_FEATURES = { flag: 'green-features', enabled: 'green_features_allowed', disabled: 'holdout' };
export const SATISFACTION_FEEDBACK_ENTITY = { flag: 'satisfaction-feedback-entity', enabled: 'sfe_enabled', disabled: 'sfe_disabled' };
export const GREEN_RELATED_SEARCHES = { flag: 'green-related-searches', enabled: 'grs_enabled', disabled: 'grs_disabled' };
